import {
  CreateConciergeSupportIssueMutation,
  CreateConciergeSupportIssueMutationVariables
} from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { useTrackEvent } from "@outschool/ui-analytics";
import { gql, useMutation } from "@outschool/ui-apollo";
import React, { useState } from "react";

import { buildUserMessage } from "../../concierge/buildUserMessage";
import { CONCIERGE_TRACKING_EVENTS } from "../../concierge/constants";
import { useChatContext } from "../chatProvider";
import { ChatInputField } from "../components/ChatInputField";
import { LearnerSelection } from "../components/LearnerSelection";

const createConciergeSupportIssueMutation = gql`
  mutation CreateConciergeSupportIssue($userMessage: String!) {
    createConciergeSupportIssue(userMessage: $userMessage)
  }
`;

export const ConciergeInput = () => {
  const {
    showErrorMessage,
    sendConciergeRequestSubmit,
    selectedLearner,
    updateSelectedLearner
  } = useChatContext();
  const [inputValue, setInputValue] = useState("");

  const { t } = useTranslation("client\\components\\chat\\conciergeChat");
  const trackEvent = useTrackEvent();

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(event.target.value);
  };

  const [createConciergeSupportIssue] = useMutation<
    CreateConciergeSupportIssueMutation,
    CreateConciergeSupportIssueMutationVariables
  >(createConciergeSupportIssueMutation);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    trackEvent(CONCIERGE_TRACKING_EVENTS.REQUEST_SUBMIT_BUTTON_TOUCH);
    const userMessage = buildUserMessage(inputValue, selectedLearner);
    try {
      await createConciergeSupportIssue({ variables: { userMessage } });
      sendConciergeRequestSubmit(inputValue, selectedLearner);
    } catch (error) {
      OsPlatform.captureError(error);
      showErrorMessage(
        inputValue,
        t`Sorry! We are not able to send your request at this time.`
      );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <ChatInputField
        inputHelperText={t(
          'Example: "My 6th grader needs help with math homework in the evenings after school, especially with geometry"'
        )}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        handleSubmit={handleSubmit}
      >
        <LearnerSelection
          label={t("Select Learner (Optional)")}
          onLearnerSelect={updateSelectedLearner}
        />
      </ChatInputField>
    </form>
  );
};
